import React from 'react';
import { useNavigate } from 'react-router-dom';

function CTA() {
  const navigate = useNavigate();
  return (
    <section className="cta-section">
      <div className="container">
        <h2 className="cta-headline">Ready to Transform Your School Management?</h2>
        <button className="btn-cta" onClick={() => navigate('/demo-form')}>Start Your Free Trial Today</button>
      </div>
    </section>
  );
}

export default CTA;
